import React from 'react';

const StatusError = () => (
  <div className="onboarding-status -error">
    <div className="onboarding-status_error">update failed</div>
    <div className="onboarding-status_description">
      don't close this tab and retry when connection resume
    </div>
  </div>
);

export default React.memo(StatusError);



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/Status/StatusError.js